import axios from "axios";

import { RestError } from "../lib/exceptions";

const DEFAULT_MAX_RETRIES = 3;

export const statusOf = (error: unknown): number | undefined => {
  if (error instanceof RestError) {
    return error.statusCode;
  }

  return axios.isAxiosError(error) ? error.response?.status : undefined;
};

export const retryUnlessClientError =
  (maxRetries: number = DEFAULT_MAX_RETRIES) =>
  (failureCount: number, error: Error): boolean => {
    const status = statusOf(error);

    if (status !== undefined && status >= 400 && status < 500) {
      return false;
    }

    return failureCount < maxRetries;
  };
